import isEmpty from 'lodash.isempty';

export function replaceEndOfLine(text) {
	if (isEmpty(text)) {
		return '';
	}

	return text.replace(/(?:\r\n|\r|\n)/g, '<br />');
}
